import { Loader } from '@devd-client/devd/components';
import React, { Suspense } from 'react';

const GitInstallation = React.memo(
  React.lazy(() =>
    import('@devd-client/devd/ui-shared').then((module) => ({
      default: module.GitInstallation,
    }))
  )
);

export function AsyncGitInstallation() {
  return (
    <Suspense fallback={<Loader />}>
      <GitInstallation />
    </Suspense>
  );
}
